import { render, staticRenderFns } from "./ShortsTable.vue?vue&type=template&id=c2900cca"
import script from "./ShortsTable.vue?vue&type=script&lang=js"
export * from "./ShortsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports